import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy, Output, EventEmitter, ChangeDetectorRef, Renderer2 } from "@angular/core";
import { LectureTilesListComponent } from "../lecture-tiles-list/lecture-tiles-list.component";
import { TokBoxService, RequestService, LayoutUtilsService } from "../../services";
import { Subscription } from "rxjs";
import { MatTabGroup } from "@angular/material/tabs";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { TranslateService } from "@ngx-translate/core";
import { AblyService } from "../../services/ably.service";

@Component({
    selector: 'app-tile-questions-answers',
    templateUrl: './tile-questions-answers.component.html',
    styleUrls: ['./tile-questions-answers.component.scss'],
    animations: [
        trigger('showDialog', [
            state('in', style({
                opacity: 0,
                top: '0%'
            })),
            state('out', style({
                opacity: 0.98,
                top: '7.5%'
            })),
            // transition('in => out', animate('500ms ease-in-out')),
            transition('in => out', animate('1500ms ease-in-out'))
        ])
    ]
})
export class TileQuestionsAnswersComponent implements OnInit, OnDestroy {

    @ViewChild('lectureTilesList') lectureTilesList: LectureTilesListComponent;
    @ViewChild('answersDraggable') answersDraggable: ElementRef;
    @ViewChild('tabGroup') tabGroup: MatTabGroup;

    @Input() session: OT.Session;
    @Input() sessionData: any = undefined;
    @Input() hideToggle: boolean = undefined;
    @Input() expanded: boolean = false;
    @Input() leads: any = undefined;
    @Input() guests: any = undefined;
    @Input() disableDrag: boolean = false;
    @Input() hasCategories: boolean = false;
    @Input() pageSize: number = 10;
    @Input() advancedView: boolean = false;
    @Input()
    set selectedData(selectedData: any) {
        if (selectedData) {
            this._selectedData = selectedData;
            this.tabGroup.selectedIndex = 0;
            this.iframeLink = this.requestService.getTileLink(this.sessionData._id, selectedData._id, true);
        }
    }
    get selectedData(): any {
        return this._selectedData;
    }
    @Input()
    set hide(hide: boolean) {
        this._hide = hide;
        if (!hide) {
            this.animationState = 'out';
            this.maximize();
        }
        else
            this.animationState = 'in';
    }

    @Output() hideDialog = new EventEmitter<boolean>(undefined);

    private subscriptions: Subscription[] = [];
    _leftPosition: any;
    _zIndex: number = 0;
    _zIndexTemp: number = 0;
    _hide: boolean = false;
    iframeLink: any = undefined;
    _selectedData: any = undefined;
    animationState: string = 'in';

    constructor(private opentokService: TokBoxService, private ref: ChangeDetectorRef, private requestService: RequestService, private renderer: Renderer2, private layoutUtilsService: LayoutUtilsService, private translate: TranslateService, private ablyService: AblyService) { }

    ngOnInit() {
        this.subscriptions.push(this.opentokService.zIndexDraggable.subscribe(value => {
            if (value != undefined) {
                this._zIndexTemp = value;
            }
        }));
    }

    ngOnDestroy() {
        this.subscriptions.forEach(el => el.unsubscribe());
    }

    dragged(bool: boolean) {
        if (bool) {
            this._zIndex = this._zIndexTemp + 1;
            this.opentokService.zIndexDraggable.next(this._zIndex);
        }
        // this.opentokService.dragged(bool, this.parentDiv, this.renderer);
    }

    maximize() {
        this.dragged(true);
        this.detectChanges();
        this._leftPosition = (document.body.offsetWidth / 2) - (this.answersDraggable.nativeElement.offsetWidth / 2);
        this.tabGroup.realignInkBar();
    }

    closeDialog() {
        this.animationState = 'in';
        this.hideDialog.emit(true);
    }

    detectChanges() {
        if (!this.ref['destroyed']) {
            this.ref.detectChanges();
        }
    }

    unPushItem(id: string) {
        this.iframeLink = undefined;
        this.opentokService.sendSignal('unPushTile', id, this.session);
        this.ablyService.sendSessionSignal(this.sessionData._id, 'unPushTile', id);
    }

    selectItemCheck(data) {
        if (!this.selectedData || (this.selectedData && this.selectedData._id !== data._id)) {
            this.selectedData = data;
            this.iframeLink = this.requestService.getTileLink(this.sessionData._id, this.selectedData._id, true);
            // this.tabGroup.selectedIndex = 1;
        }
    }

    pushedTileItem(data) {
        let dialog = this.opentokService.pushedTileItem(data, this.session, this.leads, this.guests);
        if (dialog) {
            dialog.afterClosed().subscribe(res => {
                if (res) {
                    if (res.action === 'declineText') {
                        this.layoutUtilsService.showNotification(this.translate.instant('Pushed Successfully'), this.translate.instant('Dismiss'));
                        this.opentokService.sendSignal('activatedTile', data, this.session);
                        this.ablyService.sendSessionSignal(this.sessionData._id, 'activatedTile', data);
                        this.lectureTilesList.activateTile(data);
                    } else if (res.action === 'confirmText') {
                        this.layoutUtilsService.showNotification(this.translate.instant('Pushed Successfully'), this.translate.instant('Dismiss'));
                        this.opentokService.sendSignal('activatedTileForAttendees', data, this.session);
                        this.ablyService.sendSessionSignal(this.sessionData._id, 'activatedTileForAttendees', data);
                        this.lectureTilesList.activateTile(data);
                    }
                }
            });
        };
    }
}